<template>
  <v-container class="learn-more-container">
    <v-row no-gutters>
      <v-col cols="1" class="back-arrow-container">
        <router-link :to="{ name: 'InsuranceProducts' }" class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col>
      <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 11">
        <v-row no-gutters class="learn-more-content">
          <div class="main-title-section">
            <p>
              <span class="text-decoration-underline estate">Estate</span>
              <span class="assist">Assist</span>
            </p>
          </div>
          <p class="when-you-pass-text">
            When you pass away, your loved ones could face unexpected legal and
            administrative costs, such as transferring property from your name
            to your partner’s.
          </p>
          <p class="normal-p no-money">
            If there is no money available in your estate to pay for these
            costs, they might have to sell some of the items in your estate
            (such as a house, a car or other goods) to cover the costs.
          </p>

          <p class="estate-assist-help">
            <span class="estate-assist-color-title">
              <span>Estate</span>
              <span>Assist</span>
            </span>
            is here to help. Our cover ensures that these costs are taken care
            of through a comprehensive range of services, so your family won't
            need to worry about having the cash available.
          </p>

          <h1 class="default-title">How much services cover will can I get?</h1>
          <p class="normal-p">
            Cover can be anything between R 35 000 and R 1 000 000 in services.
            We will calculate the legal and administration costs against your
            estate and provide you with cover options to choose from. The
            services will cover:
          </p>

          <div class="bullet-section">
            <ul>
              <li>Executor fees</li>
              <li>Conveyancer fees (not included in Micro)</li>
              <li>Administration Fees (including masters office fees)</li>
              <li>Testamentary Trust set up fees (if selected)</li>
            </ul>
          </div>

          <h1 class="default-title">How will the monthly payments work?</h1>

          <p class="normal-p">
            Premiums will not change for the first year. After that your monthly
            payments are expected to go up by 6% annually. These monthly
            payments will be deducted by order debit from your account. If you
            stop paying the monthly payments, your cover will stop.
          </p>

          <h1 class="default-title">Will my Cover increase Annually?</h1>

          <p class="normal-p">
            No, cover will not increase annually. If your estate grows, you will
            need to review the value of the services you require and amend your
            product accordingly.
          </p>

          <h1 class="default-title">
            Do I qualify for
            <span class="estate-assist-color-title">
              <span>Estate</span>
              <span>Assist</span>
            </span>
            ?
          </h1>

          <p class="normal-p">
            If you are between 18 and 75 years old, have a SA ID number and meet
            our simplified underwriting process requirements, you qualify for
            this cover
          </p>

          <h1 class="default-title">
            When will
            <span class="estate-assist-color-title">
              <span>Estate</span>
              <span>Assist</span>
            </span>
            not pay out?
          </h1>

          <p class="normal-p">
            If you take your own life(suicide), then you will not be covered.
          </p>

          <p class="larger-p all-products">
            <span class="estate-assist-color-title">
              <span>Estate</span>
              <span>Assist</span>
            </span>
            also offer additional benefits that can be added to your cover. 
            These are
            <span class="tax-assist-color-title">
              <span>Tax</span>
              <span>Assist</span> </span
            >,
            <span class="edu-assist-color-title">
              <span>Edu</span>
              <span>Assist</span> </span
            >,
            <span class="debt-assist-color-title">
              <span>Debt</span>
              <span>Assist</span> </span
            >,
            <span class="cash-assist-color-title">
              <span>Cash</span>
              <span>Assist</span> </span
            >.
          </p>

          <div class="horizontal-divider"></div>

          <h1 class="tax-assist-title" id="tax-assist">
            <span class="tax-assist-color-title">
              <span>Tax</span>
              <span>Assist</span>
            </span>
          </h1>

          <p class="normal-p">
            When you pass away, a TaxAssist product that covers estate duty and
            capital gains tax is essential to ensure your loved ones are not
            burdened with significant tax liabilities upon your passing. These
            taxes can reduce the inheritance left to your beneficiaries and may
            require the sale of valuable assets, such as family homes or
            businesses, to cover the costs.
          </p>

          <div class="children-future">
            <p class="normal-p">
              By providing liquidity, this product ensures your estate is
              administered smoothly, protects generational wealth, and gives you
              peace of mind that your legacy will be passed on as intended. This
              complements your broader estate planning strategy to maximize the
              benefits for your beneficiaries.
            </p>
          </div>

          <h1 class="default-title">How much cover will I need?</h1>

          <p class="normal-p">
            Cover can be anything between R 50 000 and R 1 200 000. We will
            calculate your total tax (Estate Duty and Capital Gains Tax) and
            provide that as a quote. The cover amount you choose will stay the
            same unless you ask to make it more, up to a maximum of R 1 200 000.
          </p>

          <h1 class="default-title">Who will the benefit be paid to?</h1>

          <p class="normal-p">
            In the event of your passing, the TaxAssist lump sum will be paid
            directly into your estate to help settle outstanding taxes. If any
            funds remain after all taxes have been covered, the balance will
            form part of your estate and will be distributed to your
            beneficiaries as outlined in your will.
          </p>

          <h1 class="default-title">How will the monthly payments work?</h1>

          <p class="normal-p">
            Premiums will not change for the first year. After that your monthly
            payments are expected to go up by 6% annually. These monthly
            payments will go off by debit order from your account. If you stop
            paying the monthly payments, your cover will stop.
          </p>

          <h1 class="default-title qualify-tax">
            Do I qualify for
            <span class="tax-assist-color-title">
              <span>Tax</span>
              <span>Assist</span>
            </span>
            ?
          </h1>

          <p class="normal-p">
            If you are between 18 and 75 years old, have a SA ID number and meet
            our simplified underwriting process requirements, you qualify for
            this cover
          </p>

          <h1 class="default-title qualify-tax">
            When will
            <span class="tax-assist-color-title">
              <span>Tax</span>
              <span>Assist</span>
            </span>
            not pay out?
          </h1>

          <p class="normal-p">
            If you take your own life(suicide), then you will not be covered.
          </p>

          <div class="horizontal-divider"></div>

          <h1 class="edu-assist-title" id="edu-assist">
            <span class="edu-assist-color-title">
              <span>Edu</span>
              <span>Assist</span>
            </span>
          </h1>

          <p class="normal-p">
            Parents are concerned about the future and education of their
            children. Ensuring your children can continue with their education
            without financial concerns in the event of your death is important.
            If your family is dependent on your income for your children’s
            school fees, you may want to consider EduAssist.
          </p>

          <div class="children-future">
            <p class="normal-p">
              EduAssist will make sure your children’s future is protected and
              they get the education they deserve.
            </p>
          </div>

          <h1 class="default-title">How much cover can I get?</h1>

          <p class="normal-p">
            You can get between R 5 000 and R 150 000 cover per year, per child.
            The amount you have chosen will be paid out each year. This cover
            can be used towards school fees, uniforms, stationery and transport.
            The amount chosen should cover the costs of your children’s school
            education and related expenses.
          </p>

          <h1 class="default-title">How many children does EduAssist cover?</h1>

          <p class="normal-p">
            There is no limit to the number of children you can include, however
            the total cover amount across all the Estate Assist products cannot
            exceed R 2 500 000
          </p>

          <h1 class="default-title">When will the benefit be paid out?</h1>

          <p class="normal-p">
            The amount you have chosen will be paid out each January until the
            year the covered child turns 18 (which is expected to be their
            matric year).
          </p>

          <h1 class="default-title">Who will the benefit be paid to?</h1>

          <p class="normal-p">
            In the event of your death, the sum assured will be paid to your
            nominated guardian or into a testamentary trust. The amount you have
            chosen will be paid out each year from the year in which the covered
            child turns 7, until the year in which the child turns 18. Payment
            will follow a successful claims assessment.
          </p>

          <h1 class="default-title">How will the monthly payments work?</h1>

          <p class="normal-p">
            Premiums will not change for the first year. After that your monthly
            payments are expected to increase by 6% annually.
          </p>

          <h1 class="default-title qualify-edu">
            Do I qualify for
            <span class="edu-assist-color-title">
              <span>Edu</span>
              <span>Assist</span> </span
            >?
          </h1>

          <p class="normal-p">
            If you are a parent between 18 and 65 years old, have a SA ID number
            and any of your children are currently under the age of 16 years
            old, meet our simplified underwriting process requirements and you
            qualify for this cover.
          </p>

          <h1 class="default-title qualify-edu">
            When will
            <span class="edu-assist-color-title">
              <span>Edu</span>
              <span>Assist</span>
            </span>
            not pay out?
          </h1>

          <p class="normal-p">
            If you take your own life(suicide), then you will not be covered.
          </p>

          <div class="horizontal-divider"></div>

          <h1 class="debt-assist-title" id="debt-assist">
            <span class="debt-assist-color-title">
              <span>Debt</span>
              <span>Assist</span>
            </span>
          </h1>

          <p class="normal-p">
            In the event of your death, there could still be money owing on your
            house or your car. If there is no money available in your estate to
            pay for these debts or loans, they might have to sell some of the
            items in your estate (such as a house, a car or other goods) to pay
            for it.
          </p>

          <p class="normal-p" style="margin-top: 30px">
            To prepare for this, DebtAssist will make sure there is money
            available to settle the debt amounts you have listed in your Old
            Mutual Digital Will.
          </p>

          <h1 class="default-title">How much cover will I need?</h1>

          <p class="normal-p">
            Cover can be anything between R 50 000 and R 1 200 000. We will
            calculate your total debt and provide that as a quote. The cover
            amount you choose will stay the same unless you ask to make it more,
            up to a maximum of R 1 200 000.
          </p>

          <h1 class="default-title">Who will the benefit be paid to?</h1>

          <p class="normal-p">
            In the event of your passing, the DebtAssist lump sum will be paid
            directly into your estate to help settle outstanding debts. If any
            funds remain after all debts have been covered, the balance will
            form part of your estate and will be distributed to your
            beneficiaries as outlined in your will.
          </p>

          <h1 class="default-title">How will the monthly payments work?</h1>

          <p class="normal-p">
            Premiums will not change for the first year. After that your monthly
            payments are expected to go up by 6% annually. These monthly
            payments will go off by debit from your account. If you stop paying
            the monthly payments, your cover will stop.
          </p>

          <h1 class="default-title">
            Do I qualify for
            <span class="debt-assist-color-title">
              <span>Debt</span>
              <span>Assist</span> </span
            >?
          </h1>

          <p class="normal-p">
            If you are between 18 and 75 years old, have a SA ID number and meet
            our simplified underwriting process requirements, you qualify for
            this cover
          </p>

          <h1 class="default-title">
            When will
            <span class="debt-assist-color-title">
              <span>Debt</span>
              <span>Assist</span>
            </span>
            not pay out?
          </h1>

          <p class="normal-p">
            If you take your own life(suicide), then you will not be covered.
          </p>

          <div class="horizontal-divider"></div>

          <h1 class="cash-assist-title" id="cash-assist">
            <span class="cash-assist-color-title">
              <span>Cash</span>
              <span>Assist</span>
            </span>
          </h1>

          <p class="normal-p">
            If you pass away your family may need money to survive on while the
            estate is being finalised. If there is no money available in your
            estate to help your family at this time, they will not be able to
            pay their day-to-day expenses or buy food and clothes.
          </p>

          <p class="normal-p" style="margin-top: 30px">
            To prepare for this, CashAssist will make sure there is money
            available for your family to live on while the estate is being
            wrapped up.
          </p>

          <h1 class="default-title">How much cover will I need?</h1>

          <p class="normal-p">
            Cover can be anything between R 30 000 and R 300 000. The amount
            chosen should at least cover about 3 months of your current
            expenses. The money for CashAssist will pay out within two weeks of
            all required documents being submitted.
          </p>

          <h1 class="default-title">Who will the benefit be paid to?</h1>

          <p class="normal-p">
            In the event of your passing, the CashAssist lump sum will be paid
            directly to your nominated beneficiary, providing them with
            immediate financial support for essential expenses during the estate
            administration process.
          </p>

          <p class="normal-p mt-5">
            To avoid delays, please ensure that your beneficiary details are up
            to date. If you need to make any changes or have any questions, feel
            free to contact us.
          </p>

          <h1 class="default-title">How will the monthly payments work?</h1>

          <p class="normal-p">
            Premiums will not change for the first year. After that your monthly
            payments are expected to go up by 6% annually. These monthly
            payments will go off by debit from your account. If you stop paying
            the monthly payments, your cover will stop.
          </p>

          <h1 class="default-title">
            Do I qualify for
            <span class="cash-assist-color-title">
              <span>Cash</span>
              <span>Assist</span>
            </span>
            ?
          </h1>

          <p class="normal-p">
            If you are between 18 and 75 years old, have a SA ID number and meet
            our simplified underwriting process requirements, you qualify for
            this cover
          </p>

          <h1 class="default-title">
            When will
            <span class="cash-assist-color-title">
              <span>Cash</span>
              <span>Assist</span>
            </span>
            not pay out?
          </h1>

          <p class="normal-p">
            If you take your own life(suicide), then you will not be covered.
          </p>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'LearnMore',
  };
</script>

<style lang="scss" scoped>
  .learn-more-container {
    margin-top: 16px;

    .learn-more-content {
      flex-direction: column;
    }

    .main-title-section {
      p {
        margin: 0;

        .estate {
          font-size: 38px;
          font-weight: 700;
          line-height: 46.32px;
          color: #da1572;
        }
        .assist {
          font-size: 38px;
          font-weight: 500;
          line-height: 46.32px;
          color: #000000;
        }
      }
    }

    .when-you-pass-text {
      font-size: 16px;
      font-weight: 600;
      line-height: 26px;
      margin: 0;
      margin-top: 40px;
    }

    .no-money {
      margin-top: 30px;
    }

    .normal-p {
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      text-align: left;
      margin: 0;
      width: 100%;
    }

    .larger-p {
      font-size: 20px;
      font-weight: 400;
      line-height: 26px;
      text-align: left;
      margin: 0;
      width: 100%;
    }

    .estate-assist-color-title {
      span:first-of-type {
        color: #ed0080;
        text-decoration: underline;
      }
      span:last-of-type {
        color: #282828;
      }
    }

    .edu-assist-color-title {
      span:first-of-type {
        color: #7395ef;
        text-decoration: underline;
      }
      span:last-of-type {
        color: #282828;
      }
    }

    .tax-assist-color-title {
      span:first-of-type {
        color: #e9ab21;
        text-decoration: underline;
      }
      span:last-of-type {
        color: #282828;
      }
    }

    .debt-assist-color-title {
      span:first-of-type {
        color: #d65e23;
        text-decoration: underline;
      }
      span:last-of-type {
        color: #282828;
      }
    }

    .cash-assist-color-title {
      span:first-of-type {
        color: #8dc63f;
        text-decoration: underline;
      }
      span:last-of-type {
        color: #282828;
      }
    }

    .cost-assist-color-title {
      span:first-of-type {
        color: #e9ab21;
        text-decoration: underline;
      }
      span:last-of-type {
        color: #282828;
      }
    }

    .estate-assist-help {
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      text-align: left;
      margin: 0;
      margin-top: 30px;

      .estate-assist-color-title,
      .tax-assist-color-title,
      .debt-assist-color-title,
      .cash-assist-color-title {
        span:first-of-type {
          font-size: 16px;
          font-weight: 700;
          line-height: 26px;
          text-align: left;
        }
        span:last-of-type {
          font-size: 16px;
          font-weight: 500;
          line-height: 26px;
          text-align: left;
        }
      }
    }

    .default-title {
      margin-top: 30px;
      margin-bottom: 16px;
      font-size: 20px;
      font-weight: 600;
      line-height: 26px;
      text-align: left;
      color: #282828;
    }

    .bullet-section {
      margin-top: 30px;
      width: 100%;

      ul {
        list-style-type: none;
        padding-left: 0;

        li::before {
          content: '- ';
          position: absolute;
          left: 0;
          top: 0;
        }
        li {
          position: relative;
          font-family: Montserrat;
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          color: #282828;
          padding-left: 20px;
        }
      }

      p {
      }
    }

    .all-products {
      margin-top: 30px;

      .estate-assist-color-title {
        span:first-of-type {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          text-align: left;
        }
        span:last-of-type {
          font-size: 20px;
          font-weight: 500;
          line-height: 26px;
          text-align: left;
        }
      }

      .edu-assist-color-title {
        span:first-of-type {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          text-align: left;
        }
        span:last-of-type {
          font-size: 20px;
          font-weight: 500;
          line-height: 26px;
          text-align: left;
        }
      }

      .debt-assist-color-title {
        span:first-of-type {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          text-align: left;
        }
        span:last-of-type {
          font-size: 20px;
          font-weight: 500;
          line-height: 26px;
          text-align: left;
        }
      }

      .cash-assist-color-title {
        span:first-of-type {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          text-align: left;
        }
        span:last-of-type {
          font-size: 20px;
          font-weight: 500;
          line-height: 26px;
          text-align: left;
        }
      }

      .tax-assist-color-title {
        span:first-of-type {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          text-align: left;
        }
        span:last-of-type {
          font-size: 20px;
          font-weight: 500;
          line-height: 26px;
          text-align: left;
        }
      }
    }
    .horizontal-divider {
      border: 1px solid #dfe2e5;
      width: 100%;
      margin-top: 60px;
      margin-bottom: 60px;
    }

    .edu-assist-title {
      margin-bottom: 30px;

      .edu-assist-color-title {
        span:first-of-type {
          font-size: 28px;
          font-weight: 700;
          line-height: 36.4px;
          text-align: left;
        }
        span:last-of-type {
          font-family: Montserrat;
          font-size: 28px;
          font-weight: 500;
          line-height: 36.4px;
          text-align: left;
        }
      }
    }

    .tax-assist-title {
      margin-bottom: 30px;

      .tax-assist-color-title {
        span:first-of-type {
          font-size: 28px;
          font-weight: 700;
          line-height: 36.4px;
          text-align: left;
        }
        span:last-of-type {
          font-family: Montserrat;
          font-size: 28px;
          font-weight: 500;
          line-height: 36.4px;
          text-align: left;
        }
      }
    }

    .debt-assist-title {
      margin-bottom: 30px;

      .debt-assist-color-title {
        span:first-of-type {
          font-size: 28px;
          font-weight: 700;
          line-height: 36.4px;
          text-align: left;
        }
        span:last-of-type {
          font-family: Montserrat;
          font-size: 28px;
          font-weight: 500;
          line-height: 36.4px;
          text-align: left;
        }
      }
    }

    .cash-assist-title {
      margin-bottom: 30px;

      .cash-assist-color-title {
        span:first-of-type {
          font-size: 28px;
          font-weight: 700;
          line-height: 36.4px;
          text-align: left;
        }
        span:last-of-type {
          font-family: Montserrat;
          font-size: 28px;
          font-weight: 500;
          line-height: 36.4px;
          text-align: left;
        }
      }
    }

    .children-future {
      margin-top: 30px;
    }

    .qualify-edu {
      .edu-assist-color-title {
        span:first-of-type {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          text-align: left;
        }
        span:last-of-type {
          font-size: 20px;
          font-weight: 600;
          line-height: 26px;
          text-align: left;
        }
      }
    }
    .qualify-tax {
      .tax-assist-color-title {
        span:first-of-type {
          font-size: 20px;
          font-weight: 700;
          line-height: 26px;
          text-align: left;
        }
        span:last-of-type {
          font-size: 20px;
          font-weight: 600;
          line-height: 26px;
          text-align: left;
        }
      }
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .back-arrow-container {
      margin-bottom: 16px;
    }
  }
</style>
